// AGC: Assignee selector — dropdown of team members
import React from 'react'
import { Check } from 'lucide-react'
import type { VoiceFieldProps } from './types'

export const AssigneeField: React.FC<VoiceFieldProps> = ({
  info,
  inputValues,
  setInputValues,
  wizardMode,
}) => {
  // AGC: Sizing classes — bigger in wizard mode to fill the full-screen card layout
  const sz = wizardMode
    ? { card: 'p-5', label: 'text-base', btn: 'px-4 py-3.5 text-base', checkIcon: 'w-5 h-5' }
    : { card: 'p-2', label: 'text-xs', btn: 'px-2 py-1.5 text-xs', checkIcon: 'w-3 h-3' }

  return (
    <div className={`${sz.card} bg-white/5 border border-white/20 rounded-xl`}>
      <div className="mb-3">
        <span className={`text-white/80 ${sz.label} font-medium flex items-center gap-1`}>
          👤 {info.fieldLabel}
        </span>
        {info.reason && (
          <p className="text-white/40 text-xs mt-0.5">{info.reason}</p>
        )}
      </div>
      <div className="space-y-1 max-h-36 overflow-y-auto">
        {info.suggestions?.map((s: { value: string; label: string }) => (
          <button
            key={s.value}
            onClick={() => setInputValues(prev => ({
              ...prev,
              assignee: s.value,
              assigneeName: s.label.replace(/^👤\s*/, ''),
            }))}
            className={`w-full flex items-center justify-between ${sz.btn} rounded text-left transition-colors ${
              (inputValues.assignee || 'self') === s.value
                ? 'bg-emerald-500/30 border border-emerald-500/50 text-emerald-300 font-medium'
                : 'bg-white/5 hover:bg-white/10 text-white/80 border border-transparent'
            }`}
          >
            <span className="truncate">{s.label}</span>
            {(inputValues.assignee || 'self') === s.value && <Check className={`${sz.checkIcon} flex-shrink-0`} />}
          </button>
        ))}
      </div>
    </div>
  )
}
